import React from 'react';
import RoomIcon from './RoomIcon';
import './UserList.css';

export default function UserList({ users, voiceUsers }) {
  return (
    <div className="user-list">
      {users.length === 0 && (
        <div className="users-empty">Нет участников</div>
      )}
      {users.map(user => {
        // user.inVoice приходит от сервера (авторитетно для всех участников,
        // независимо от порядка входа); voiceUsers — локальная подстраховка.
        const inVoice = user.inVoice || (voiceUsers && voiceUsers[user.id]);
        return (
          <div key={user.id} className="user-item">
            <div className="user-avatar">
              {(user.name || 'А')[0].toUpperCase()}
            </div>
            <div className="user-info">
              <span className="user-name">{user.name || 'Аноним'}</span>
              {inVoice && <span className="user-voice-badge" title="В голосовом чате"><RoomIcon name="mic" size={14} /></span>}
            </div>
            <div className="user-status">
              <span className="status-dot online" />
            </div>
          </div>
        );
      })}
    </div>
  );
}
